export const LOGIN_ATTEMPTS_KEY = 'loginAttempts';
export const LOCK_TIME_KEY = 'lockoutTime';
export const MAX_CLIENT_ATTEMPTS = 5;
export const CLIENT_LOCK_DURATION_MS = 4 * 60 * 1000; // 4 minutes

export const getAttempts = () => {
    return parseInt(localStorage.getItem(LOGIN_ATTEMPTS_KEY) || 0);
};

export const incrementAttempts = () => {
    const newAttempts = getAttempts() + 1;
    localStorage.setItem(LOGIN_ATTEMPTS_KEY, newAttempts);
    return newAttempts;
};

export const clearAttempts = () => {
    localStorage.removeItem(LOGIN_ATTEMPTS_KEY);
    localStorage.removeItem(LOCK_TIME_KEY);
};

export const isClientLocked = () => {
    const lockTime = parseInt(localStorage.getItem(LOCK_TIME_KEY));
    if (!lockTime) return false;

    if (lockTime > Date.now()) {
        const remainingSeconds = Math.ceil((lockTime - Date.now()) / 1000);
        return { isLocked: true, remaining: remainingSeconds };
    } else {
        localStorage.removeItem(LOCK_TIME_KEY);
        localStorage.removeItem(LOGIN_ATTEMPTS_KEY);
        return { isLocked: false, remaining: 0 };
    }
};